import React from 'react';
import {observer} from 'mobx-react';
import {withState, t} from 'shared/core';
import {Flow} from 'main/components';
import {PolicyEditFlowState} from '../state';
import {Step} from '../components';

const PolicyEditFlow = observer(({uiState}) => {
  const {policy, steps} = uiState;

  return (
    <Flow
      name={policy.name}
      baseUrl={`/policies/${policy.id}/edit`}
      backTitle={t('time_off.policy.edit.Policies')}
      backRoute='/policies'
      steps={steps}
      component={Step}
      uiState={uiState}
      onStepChanged={step => uiState.onStepChanged(step)}
      onStepSubmitted={(step) => uiState.onStepSubmitted(step)}
    />
  );
});

export default withState(PolicyEditFlow, PolicyEditFlowState);
